import { useCallback, useEffect, useRef, useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { FeatureFlagUseCase } from '@ibk/shared-types';
export function usePaymentBilletRevision({ onConfirm, }) {
    const { t } = useTranslation();
    const [confirmText, setConfirmText] = useState(t('confirm'));
    const [openCalendar, setOpenCalendar] = useState(false);
    const anchorRef = useRef(null);
    const [isSchedulingEnabled, setIsSchedulingEnabled] = useState(false);
    const hasCheckedScheduling = useRef(false);
    const { isFeatureFlagWhiteListed, getFeatureFlags } = useFeatureFlag(undefined, {
        autoLoad: false,
    });
    useEffect(() => {
        if (hasCheckedScheduling.current)
            return;
        const checkSchedulingEnabled = async () => {
            hasCheckedScheduling.current = true;
            const featureFlagsData = await getFeatureFlags(true);
            const isSchedulingEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.PAGAMENTOS_SCHEDULE_BILLET_PAYMENT_ACCOUNTANT, undefined, featureFlagsData);
            const isSchedulingEnabledEmployee = isFeatureFlagWhiteListed(FeatureFlagUseCase.PAGAMENTOS_SCHEDULE_BILLET_PAYMENT_EMPLOYEE, undefined, featureFlagsData);
            const isSchedulingEnabledClient = isFeatureFlagWhiteListed(FeatureFlagUseCase.PAGAMENTOS_SCHEDULE_BILLET_PAYMENT_CLIENT, undefined, featureFlagsData);
            setIsSchedulingEnabled(isSchedulingEnabled || isSchedulingEnabledEmployee || isSchedulingEnabledClient);
        };
        checkSchedulingEnabled();
    }, [isFeatureFlagWhiteListed, getFeatureFlags]);
    const handleConfirm = useCallback(() => {
        setConfirmText(t('complete-payment'));
        onConfirm();
    }, [onConfirm, t]);
    return {
        confirmText,
        openCalendar,
        setOpenCalendar,
        handleConfirm,
        anchorRef,
        isSchedulingEnabled,
    };
}
